import React, { useEffect, useState } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { formatMoneda } from "../../../util/varios";
import axios from "axios";

export default function Cartas(props) {
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../modulos/datos");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState({
    cantidad_productos: 0,
    cantidad_proveedores: 0,
    monto_total: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const cards = [
    {
      title: "TOTAL DE PRODUCTOS",
      value: records.cantidad_productos,
      gradient: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
      icon: "fas fa-file-alt",
      subtitle: "Total de Productos ",
    },
    {
      title: "TOTAL DE PROVEEDORES",
      value: records.cantidad_proveedores,
      gradient: "linear-gradient(135deg, #0ba360 0%, #3cba92 100%)",
      icon: "fas fa-building",
      subtitle: "Total de Proveedores",
    },
    {
      title: "MONTO TOTAL",
      value: `Bs. ${formatMoneda(
        records.monto_total.toString().replace(".", ","),
        ",",
        ".",
        2,
      )}`,
      gradient: "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)",
      icon: "fas fa-chart-line",
      subtitle: "Monto total en Bs.",
    },
  ];

  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/comprasAlmacen/cartasCompras?idFiscal=${props.idFiscal}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setRecords(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Registros de las Tablas",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    buscarRegistros();
  }, [props.idFiscal]);
  return (
    <div className="row">
      {cards.map((card, index) => (
        <div key={index} className="col-sm-6 col-lg-4">
          <div
            className="card h-100 border-0 overflow-hidden position-relative"
            style={{
              background: card.gradient,
              borderRadius: "20px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
            }}
          >
            {/* Círculos decorativos */}
            <div
              style={{
                position: "absolute",
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.08)",
                pointerEvents: "none",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: -30,
                left: -30,
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.05)",
                pointerEvents: "none",
              }}
            ></div>

            <div
              className="card-body p-3 p-md-4 position-relative"
              style={{ zIndex: 1 }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <small
                    className="text-uppercase fw-bold"
                    style={{
                      letterSpacing: "2px",
                      fontSize: "0.7rem",
                      opacity: 0.85,
                      color: "white",
                    }}
                  >
                    {card.title}
                  </small>
                  <h3
                    className="mb-1 mt-2 fw-bold"
                    style={{
                      color: "white",
                      fontSize: "clamp(1.5rem, 4vw, 1.6rem)",
                    }}
                  >
                    {card.value}
                  </h3>
                  {card.subtitle && (
                    <small
                      style={{
                        color: "rgba(255,255,255,0.7)",
                        fontSize: "0.7rem",
                      }}
                    >
                      {card.subtitle}
                    </small>
                  )}
                </div>
                <div className="ms-3">
                  <i
                    className={card.icon}
                    style={{
                      color: "rgba(255,255,255,0.2)",
                      fontSize: "3rem",
                      filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      <Dimmer active={loading} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
    </div>
  );
}
